import styled from 'styled-components'

export const Video = styled.video`
    position: absolute;
`
